/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum FooterAliases {
  ADDRESS_PANEL = 'address-panel',
  ADDRESS_TEXT = 'address-text',
  COMPLEMENT_LAYOUT = 'complement-layout',
  EMAIL_PANEL = 'email-panel',
  EMAIL_TEXT = 'email-text',
  EMAIL_TITLE_TEXT = 'emailTitle-text',
  FOOTER_LAYOUT = 'footer-layout',
  INFO_LAYOUT = 'info-layout',
  INFO_PANEL = 'info-panel',
  LAYOUT_0 = 'layout-0',
  LAYOUT_1 = 'layout-1',
  LAYOUT_2 = 'layout-2',
  LINK_DEPENDENCIES = 'link-dependencies',
  LINK_VERSION = 'link-version',
  PANEL_VERSION = 'panel-version',
  PHONE_PANEL = 'phone-panel',
  PHONE_TEXT = 'phone-text',
  PHONE_TITLE_TEXT = 'phoneTitle-text',
  SOCIAL_FETCH = 'social-fetch',
  SOCIAL_NETWORKS = 'social-networks',
  SOCIAL_PANEL = 'social-panel',
  TEXT_0 = 'text-0',
}
export { FooterAliases };
